import React from 'react';
import { ArrowRight, ShieldAlert } from 'lucide-react';

export const UpiCutoffCard = () => (
  <section className="rounded-2xl border border-amber-200 bg-amber-50/80 p-4 sm:p-5" aria-labelledby="upi-cutoff-heading">
    <div className="flex items-start gap-3">
      <span className="w-9 h-9 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0">
        <ShieldAlert className="w-5 h-5" />
      </span>
      <div>
        <h2 id="upi-cutoff-heading" className="text-sm font-extrabold text-amber-900">
          SEBI UPI Mandate Cut-Off
        </h2>
        <p className="text-[11px] text-amber-700">As per NPCI &amp; SEBI guidelines</p>
      </div>
    </div>
    <p className="mt-3 text-xs text-amber-900/80 leading-relaxed">
      UPI mandates for a closing issue must be approved in your banking app by <strong>5:00 PM IST</strong> on the
      closing date. Mandates approved later are rejected by the clearing house.
    </p>
    {/* <div className="mt-3 flex items-center justify-between gap-2 text-[11px]">
      <span className="font-bold text-amber-800">T+3 listing timeline in effect</span>
      <a href="#calendar-faq" className="inline-flex items-center gap-1 font-bold text-amber-800 hover:underline">
        Allotment rules
        <ArrowRight className="w-3 h-3" />
      </a>
    </div> */}
  </section>
);
